import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { DocumentosDragDropComponent } from 'projects/modulo-solicitudes/src/shared/components/documentos-drag-drop/documentos-drag-drop.component';
import { ImagenesService } from 'projects/modulo-solicitudes/src/shared/services/imagenes.service';


var reader  = new FileReader();

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit {
@ViewChild(DocumentosDragDropComponent) child: DocumentosDragDropComponent;
@Input() Documento: FormGroup
@Input() docProps = {nombre:'Vacio', extension: 'vacio'};
@Input() archivoId: String
@Input() urlsArray: [];
@Input() docUrl;
@Input() fileNames;
showImageUpload: Boolean = false;
maxSize:any

  constructor(private imagenesService: ImagenesService, private dialog: MatDialog ) { }

  ngOnInit(): void {
	  this.Documento.get('ArchivoId').setValue(this.archivoId);
	  this.Documento.get('Nombre').setValue(this.fileNames);
	  if(this.docUrl === undefined) this.docUrl = ''
	  if(this.docUrl !== '') this.docUrl = [this.docUrl]
	  if(this.Documento.get('ArchivoId').value === '' || this.Documento.get('ArchivoId').value === 0 || this.Documento.get('ArchivoId').value === undefined ){
		this.showImageUpload = true;
	  }else{
		this.showImageUpload = false;
	  }
  }


  loadFile(files){
	const file = files[0];
	const imgService = this.imagenesService;
	const archivoId = this.Documento.get('ArchivoId');
	const nombre = this.Documento.get('Nombre');
	reader.readAsDataURL(file);
	reader.onloadend = () => {
		const blob = {
		Nombre: file.name,
		Tamano: file.size,
		Archivo: reader.result
		}
		imgService.cargarImagen(blob).subscribe(res => {
			archivoId.setValue(res);
			nombre.setValue(file.name)
		})
	}
	this.showImageUpload = false;
	this.child.ChangeShowDragAndDrop(this.showImageUpload);
	this.child.ChangeFileName(file.name)

  }


cleanDocument(){
	this.Documento.get('ArchivoId').setValue(0);
	this.Documento.get('Nombre').setValue(null);
}



}
